import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { UserAddress } from '../../types/user-address';

type UseCaseInput = void;

type UseCaseOutput = UserAddress | null;

export class GetSelectedAddressUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  async execute(): Promise<UseCaseOutput> {
    const stored = localStorage.getItem('selected-address');

    if (!stored) {
      return null;
    }

    const parsedAddress = JSON.parse(stored) as UserAddress;

    // Validar se o endereço tem os campos obrigatórios
    if (!parsedAddress.id || !parsedAddress.street || !parsedAddress.city) {
      localStorage.removeItem('selected-address');
      throw new Error('Endereço selecionado inválido');
    }

    return parsedAddress;
  }
}
